var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"app"}},[_c('Navbar',{attrs:{"id":"nav"}}),_c('Burger',{attrs:{"id":"burguer"}}),(_vm.scrolledToBottom == false)?_c('span',[_c('SocialMedia',{attrs:{"id":"socialMedia"}})],1):_vm._e(),_c('transition',{attrs:{"name":"fade","mode":"out-in"}},[_c('router-view')],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }